export { default, type LogoProps, Logo } from './Logo';

export const LIPS_LOGO = '/images/logo/lips-logo.png';
export const LIPS_LOGO_FAVICON = '/images/logo/lips-logo-favicon.png';
export const LIPS_PARTNERED_LOGO =
  '/images/logo/lips-healthcare-partnered-with-affidea.png';
export const LIPS_PARTNERED_LOGO_WHITE =
  '/images/logo/lips-healthcare-partnered-with-affidea-white.png';
